// extracted by mini-css-extract-plugin
export var aboutSection = "AboutSection-module--aboutSection--3nZsl";
export var aboutSectionMain = "AboutSection-module--aboutSectionMain--llLlh";
export var moreCards = "AboutSection-module--moreCards--362Ob";
export var adSection = "AboutSection-module--adSection--3nOqR";
export var ad = "AboutSection-module--ad--wtfWA";
export var adHeader = "AboutSection-module--adHeader--phVVP";
export var adText = "AboutSection-module--adText--150Op";
export var adIcon = "AboutSection-module--adIcon--T0947";